import { render, staticRenderFns } from "./SharedAlbums.vue?vue&type=template&id=d05e7eac&scoped=true"
import script from "./SharedAlbums.vue?vue&type=script&lang=js"
export * from "./SharedAlbums.vue?vue&type=script&lang=js"
import style0 from "./SharedAlbums.vue?vue&type=style&index=0&id=d05e7eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05e7eac",
  null
  
)

export default component.exports